import { makeStyles } from '@material-ui/core';
import * as React from 'react';
import { useMemo } from 'react';
import {
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    sanitizeListRestProps,
} from 'react-admin';
import { ImportButton } from "react-admin-import-csv";

const useStyles = makeStyles(theme => ({
    import: {
        backgroundColor: theme.palette.secondary.contrastText
    },
    root: {
        '& .add-filter': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            marginLeft: '.5rem',
            marginRight: '.5rem',
            fontWeight: 'bold',
            fontSize: '0.75rem',
            paddingRight: '0.6rem',
            '&:hover': {
                boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
            }
        },
        '& .MuiButton-containedPrimary': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            marginLeft: '.5rem',
            marginRight: '.5rem',
        }
    },
    button: {
    },
}))

const ListActions = (props: any) => {
    const classes = useStyles()

    const {
        currentSort,
        className,
        resource,
        filters,
        displayedFilters,
        importer,
        exporter,
        filterValues,
        permanentFilter,
        hasCreate,
        basePath,
        selectedIds,
        onUnselectItems,
        showFilter,
        total,
        ...rest
    } = props

    // console.log(props)
    return useMemo(
        () => (
            <TopToolbar className={classes.root} {...sanitizeListRestProps(rest)}>
                {hasCreate && <CreateButton
                    variant="contained"
                    className={classes.button}
                    basePath={basePath}
                />}
                <FilterButton
                    className={classes.button}
                />
                {exporter !== false &&
                    <ExportButton
                        disabled={total === 0}
                        className={classes.button}
                        variant="contained"
                        resource={resource}
                        sort={currentSort}
                    // filter={{ ...filterValues, ...permanentFilter }}
                    />}
                {importer !== false && <ImportButton
                    className={classes.button}
                    variant="contained"
                    {...props}
                />}
            </TopToolbar>
        ),
        [resource, displayedFilters, filterValues, selectedIds, filters, total] // eslint-disable-line react-hooks/exhaustive-deps
    )
}

export default ListActions